export const INMOBILIARIA_MODULE_NAME = "inmobiliaria_module";

export const inmobiliariaModuleMenuItem = {
  icon: "home",
  path: "/inmobiliaria",
};

export const inmobiliariaModuleRoutes = [
  {
    path: "inmobiliaria",
    name: "InmobiliariaHome",
    components: {
      default: () => import("./pages/InmobiliariaHome.vue"),
    },
    meta: {
      title: "Inmobiliaria",
      requiresAuth: true,
      requiresModule: INMOBILIARIA_MODULE_NAME,
    },
  },
];

export default {
  moduleName: INMOBILIARIA_MODULE_NAME,
  routes: inmobiliariaModuleRoutes,
  menuItem: inmobiliariaModuleMenuItem,
};
